import { ActionIcon, Box, Button, Group, Text } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { useAppSelector } from "app/hooks";
import { OrgPermissions, Reminder } from "beitary-shared";
import {
  ArchiveConfirmationModal,
  BBox,
  BDataTable,
  DearchiveConfirmationModal,
  DeleteConfirmationModal,
} from "components";
import { selectReminders } from "features/admin/client-communication/ClientCommunication.slice";
import { useDBServices } from "hooks/useDBService/useDBService";
import { BCan } from "permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BDataTableColumn } from "schemas-types";

type RemindersTableItem = Reminder & { actions?: undefined };

export const RemindersTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const reminders = useAppSelector(selectReminders);

  const tableItems: RemindersTableItem[] = reminders;

  const { deleteReminder, archiveReminder, dearchiveReminder } =
    useDBServices().clientCommunication.reminders;

  const columns: BDataTableColumn<RemindersTableItem>[] = [
    { accessor: "name", title: <Text>{t("NAME")}</Text>, sortable: true },
    {
      accessor: "status",
      title: <Text>{t("STATUS")}</Text>,
      sortable: true,
      render: ({ status }) => (
        <Text color={status === "ACTIVE" ? "dark" : "dimmed"}>{t(status)}</Text>
      ),
    },
    {
      accessor: "actions",
      title: "",
      width: 140,
      render: (item) => (
        <BCan I="do" a={OrgPermissions.CLIENT_COMMUNICATION}>
          <Group position="right">
            <ActionIcon onClick={() => navigate(`edit/${item.id}`)}>
              <IconEdit size={18} />
            </ActionIcon>
            {item.status === "ARCHIVED" ? (
              <DearchiveConfirmationModal
                f={async () => dearchiveReminder(item.id)}
                item={item}
              />
            ) : (
              <ArchiveConfirmationModal
                f={async () => archiveReminder(item.id)}
                item={item}
              />
            )}
            <DeleteConfirmationModal
              f={async () => deleteReminder(item.id)}
              item={item}
            />
          </Group>
        </BCan>
      ),
    },
  ];

  return (
    <BBox
      header={
        <Group position="apart">
          <Text size="sm" weight={500}>
            {t("REMINDERS_LIST")}
          </Text>
          <BCan I="do" a={OrgPermissions.CLIENT_COMMUNICATION}>
            <Button onClick={() => navigate("new")}>{t("ADD_NEW")}</Button>
          </BCan>
        </Group>
      }
    >
      <Box p="xl">
        <BDataTable
          data={tableItems}
          columns={columns}
          defaultSortKey={"name"}
        />
      </Box>
    </BBox>
  );
};
